module.exports = __webpack_public_path__ + "img/how_shop_5.fbc1b561.png";